/**
 * Toast — temporary message display.
 */
import React from 'react';
import { useSelector } from 'react-redux';

const Toast = () => {
  const message = useSelector((state) => state.game.message);

  if (!message) return null;

  return (
    <div className="fixed top-16 left-1/2 -translate-x-1/2 z-50">
      <div className="bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 px-5 py-3 rounded-lg font-bold text-sm shadow-lg animate-fade-in">
        {message}
      </div>
    </div>
  );
};

export default Toast;
